<template>
  <b-card>
    <FormBuilder
      label="Product"
      update
      :data="$store.state.product.detailData"
      :fields="fields"
      :loading-detail="$store.state.product.loadingDetail"
      :loading-submit="$store.state.product.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/product'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('product/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('product/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('product/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
